import 'arrive';

document.arrive('.block-footer', { existing: true }, function (el) {
    const isMobile = () => window.innerWidth < 992;

    const toggles = el.querySelectorAll('.block-footer__menu-toggle');

    toggles.forEach((btn) => {
        const contentId = btn.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;
        if (!content) return;

        btn.addEventListener('click', () => {
            if (!isMobile()) return;
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!isOpen));
            btn.classList.toggle('is-open', !isOpen);
            content.classList.toggle('is-open', !isOpen);
        });
    });

    // Su resize verso desktop: resetta tutto allo stato chiuso
    // (su desktop il contenuto è sempre visibile via CSS)
    window.addEventListener('resize', () => {
        if (!isMobile()) {
            toggles.forEach((btn) => {
                btn.setAttribute('aria-expanded', 'false');
                btn.classList.remove('is-open');
                const contentId = btn.getAttribute('aria-controls');
                const content = contentId ? document.getElementById(contentId) : null;
                if (content) content.classList.remove('is-open');
            });
        }
    });
});
